import { FC, useContext } from 'react';
import PageLayout from '../../layout/PageLayout/PageLayout';
import Register3rdPartyContext, {
    Register3rdPartyProvider,
    ERegister3rdPartyUiState,
} from '../../contexts/Register3rdPartyContext';
import CardLoader, { Loader } from '../../components/Loader/Loader';
import Register3rdPartyForm from '../../components/Register3rdPartyForm/Register3rdPartyForm';
import { Route, Switch, Redirect } from 'react-router';
import { ERoutes } from '../../util/constants';
import Register3rdPartyConfirm from '../../components/Register3rdPartyConfirm/Register3rdPartyConfirm';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { Stack } from '@mui/material';

const Register3rdPartyRouter: FC = () => {
    return (
        <Switch>
            <Route exact path={ERoutes.register}>
                <Register3rdPartyForm />
            </Route>
            <Route path={ERoutes.registerConfirm}>
                <Register3rdPartyConfirm />
            </Route>
        </Switch>
    );
};

const Register3rdPartyScreenUi: FC = () => {
    const { register3rdPartyUiState, redirectUrl } = useContext(Register3rdPartyContext);
    let registerUi: React.ReactElement;
    switch (register3rdPartyUiState) {
        case ERegister3rdPartyUiState.default:
        case ERegister3rdPartyUiState.initialized:
            registerUi = (
                <PageLayoutV2 showFooter={false}>
                    <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                        <Loader />
                    </Stack>
                </PageLayoutV2>
            );
            break;
        case ERegister3rdPartyUiState.ready:
        case ERegister3rdPartyUiState.loading:
            registerUi = <Register3rdPartyRouter />;
            break;
        case ERegister3rdPartyUiState.error:
            registerUi = <Redirect to={ERoutes.error} />;
            break;
        case ERegister3rdPartyUiState.confirm:
            registerUi = (
                <>
                    <Redirect push to={ERoutes.registerConfirm} />
                    <Register3rdPartyRouter />
                </>
            );
            break;
        case ERegister3rdPartyUiState.success:
            registerUi = (
                <>
                    <PageLayout>
                        <CardLoader />
                    </PageLayout>
                    {window.location.assign(redirectUrl)}
                </>
            );
            break;
        default:
            throw new Error('Register Third Party State set set incorrectly');
    }
    return registerUi;
};

const Register3rdPartyScreen: FC = () => {
    return (
        <Register3rdPartyProvider>
            <Register3rdPartyScreenUi />
        </Register3rdPartyProvider>
    );
};

export default Register3rdPartyScreen;
